/* eslint-disable */
// This file is automatically generated and should not be edited directly.
// Please edit the corresponding SVG file

import React from 'react';

const Search = (props: any) => (
<svg {...props}   viewBox="0 0 24 24" fill="inherit" xmlns="http://www.w3.org/2000/svg">
<g id="search">
<path id="Union" fillRule="evenodd" clipRule="evenodd" d="M15.6447 6.62891C18.1343 9.11851 18.1343 13.1549 15.6447 15.6445C13.1551 18.1341 9.11872 18.1341 6.62913 15.6445C4.13953 13.1549 4.13953 9.11851 6.62913 6.62891C9.11872 4.13932 13.1551 4.13932 15.6447 6.62891ZM17.442 15.8566C19.7572 12.7719 19.5117 8.37456 16.7054 5.56825C13.63 2.49287 8.64385 2.49287 5.56847 5.56825C2.49309 8.64363 2.49309 13.6298 5.56847 16.7052C8.55497 19.6917 13.3434 19.778 16.4341 16.9641C16.4361 16.9662 16.4382 16.9683 16.4402 16.9703L19.6222 20.1523C19.9151 20.4452 20.39 20.4452 20.6829 20.1523C20.9758 19.8594 20.9758 19.3846 20.6829 19.0917L17.5009 15.9097C17.482 15.8908 17.4623 15.8731 17.442 15.8566Z" fill="#282828"/>
</g>
</svg>
);

export default Search;